import SaveConfigurationButton from './SaveConfigurationButton'
import saveConfigurationContainer from './saveConfigurationContainer'

export default saveConfigurationContainer(SaveConfigurationButton)
